export default __webpack_public_path__ + "static/media/dryer.92279237.svg";